import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { List } from 'immutable';
import { ButtonWithIcon } from '@els/els-react--button';
import { SingleSelect } from '@els/els-react--select';

import { createAvailableResultsOptions } from '../AvailableResultsList';

import './ResultsFrom.scss';

export default function ResultsFrom({ results, className, id, alert, fetchResultsInfo, selectResultOfAlert, selectedRunId }) {
  const disabled = results?.size === 0 || !selectedRunId;
  const options = createAvailableResultsOptions(results);

  return (
    <section className={classnames('results-from', className)}>
      {/* The select carries "Results from" as its accessible name, so this visible copy is
            hidden from assistive tech to avoid announcing the same label twice */}
      <span className="results-from--text" aria-hidden="true">
        Results from:
      </span>

      <SingleSelect
        id={`alert-results-from-${id}`}
        data-e2e={`alert-results-from-${id}`}
        className="results-from--select"
        label="Results from"
        shouldHideLabel
        required
        hideRequired
        isDisabled={disabled}
        options={options}
        selectedOptions={selectedRunId ? [selectedRunId] : []}
        placeholderText="No alert results"
        optionsFlyoutProps={{ maxHeight: '16rem' }}
        onSelect={(option) => {
          if (option) {
            selectResultOfAlert(id, option.value);
          }
        }}
      />

      <ButtonWithIcon
        data-e2e={`alert-go-to-results-button-${id}`}
        className={`alert-right-block--go-button e2e-alert-go-${id}`}
        type="primary"
        sprite="ChevronRight"
        iconOnly
        disabled={disabled}
        onClick={() => {
          fetchResultsInfo(alert, selectedRunId);
        }}>
        Go to results
      </ButtonWithIcon>
    </section>
  );
}

ResultsFrom.propTypes = {
  id: PropTypes.string,
  results: PropTypes.instanceOf(List),
  className: PropTypes.string,
  alert: PropTypes.object,
  fetchResultsInfo: PropTypes.func,
  selectResultOfAlert: PropTypes.func,
  selectedRunId: PropTypes.string,
};
